export default __webpack_public_path__ + "static/media/quotation-management.f78debb5.svg";